import React from 'react';
import LocalizedDate from '../Localization/LocalizedDate';

export default class TitleAutocompleteRow extends React.Component {
	render() {
		const { product } = this.props;
		var uri =
			product &&
			product.images &&
			product.images.filter(im => im.type === 'jacketCover').length > 0 &&
			product.images.filter(im => im.type === 'jacketCover')[0].uri +
				'?height=200';
		return (
			<div className="clickable" key={`image-${product.sku}`}>
				<div
					className="column relative"
					style={{ maxWidth: '70px', overflow: 'hidden' }}>
					{uri ? (
						<img
							style={{
								height: '80px',
							}}
							alt={product.name}
							title={product.name}
							src={uri}
						/>
					) : (
						<div />
					)}
				</div>
				<div
					className="column-spaced"
					style={{
						width: '200px',
						fontSize: '13px',
						lineHeight: '18px',
					}}>
					<div
						className="acc-font bold dotDot full-width"
						title={product.name}>
						{product.name}
					</div>
					<div className="dotDot full-width">{product.author}</div>
					<div
						className="dotDot full-width"
						style={{ fontSize: '11px' }}>
						{product.supplier}
					</div>
					<div
						className="dotDot full-width"
						style={{ fontSize: '11px' }}>
						{product.pubDate !== '0001-01-01T00:00:00' && (
							<React.Fragment>
								<LocalizedDate dateString={product.pubDate} />
								&nbsp;&bull;&nbsp;
							</React.Fragment>
						)}
						{product.format}
					</div>
				</div>
				<div className="clear" />
			</div>
		);
	}
}
